import { contact } from "../utils/postmark";
import useFormAccount from "./useFormAccount";

function useFormContact(toEmail, subject) {
  return useFormAccount(async (input) => {
    const { firstName, lastName, email, body } = input;
    try {
      await contact({
        to: toEmail,
        from: email,
        subject,
        body: `
          Name: ${firstName} ${lastName}<br>
          Email: ${email}<br>
          Message: ${body}
        `,
      });
    } catch (e: any) {
      console.error(e);
    }

    return "Form submitted!";
  });
}

export default useFormContact;
